export default "__VITE_ASSET__1fb05931__"